import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';

class IndicatorsAllocation {
  @prop()
  misconfigurations: number;

  @prop()
  applications: number;

  @prop()
  humanBased: number;
}

export class CompanyScoreBreakdown {
  @prop()
  finalScore: number;

  @prop({ type: IndicatorsAllocation })
  indicatorsAllocation: IndicatorsAllocation;
}

class CompanyScoreHistory {
  @prop({ required: true })
  date: Date;

  @prop({ required: true, type: CompanyScoreBreakdown })
  scoreBreakdown: CompanyScoreBreakdown;
}

@modelOptions({ schemaOptions: { collection: 'companyState' }, options: { customName: 'companyState' } })
export class CompanyStateModel {
  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true })
  companyName: string;

  @prop({ required: true })
  date: Date;

  @prop({ required: true })
  industry: number;

  @prop({ required: true, type: CompanyScoreBreakdown })
  scoreBreakdown: CompanyScoreBreakdown;

  @prop({ required: true, type: CompanyScoreHistory })
  scoreHistory: CompanyScoreHistory[];
}
